import { Component, EventEmitter, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-swarm-credit-card',
    templateUrl: './swarm-credit-card.component.html',
    styleUrls: ['./swarm-credit-card.component.scss'],
    standalone: false
})
export class SwarmCreditCardComponent implements OnInit, OnDestroy {

  @Input()
  IBAN!: string | undefined;

  @Input()
  name!: string | undefined;

  @Input()
  expirationDate!: string | undefined;

  @Input()
  securityCode!: string | undefined;

  @Input()
  cardNumber!: string | undefined;

  @Input()
  bankName!: string | undefined;

  @Input()
  IBAN_Text = 'IBAN';

  @Input()
  nameText = 'Name';

  @Input()
  expirationText = 'Ablauf';

  @Input()
  securityCodeText = 'Sicherheitscode';

  @Input()
  cardNumberText = 'Nr. ';

  @Input()
  onFocus: EventEmitter<boolean> = new EventEmitter<boolean>();
  flipped!: boolean;

  private _unsubscribeAll: Subject<any>;


  constructor() {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }


  flip(flip: boolean): void {
    this.flipped = flip;
  }

  onFocusRequested(flip: boolean): void {
    this.onFocus.emit(flip);
  }
}
